/* eslint-disable no-unused-vars */
import React, { useContext } from 'react';
import axios from 'axios';
import { CotizadorContext } from '../context';

const useSocialMediaData = () => {
    const [state, setState] = useContext(CotizadorContext)

    const getSocialMedia = async () => {
        const response = await axios.get("/api/kinto/social_media_links");
        setState(prevState => ({
            ...prevState,
            social_media: response?.data
        }))
    }

    return {
        social_media: state.social_media,
        getSocialMedia,
    };
}

export default useSocialMediaData;